import { render } from "./LegalInfo.vue?vue&type=template&id=824e3a0c&scoped=true"
import script from "./LegalInfo.vue?vue&type=script&lang=js"
export * from "./LegalInfo.vue?vue&type=script&lang=js"

import "./LegalInfo.vue?vue&type=style&index=0&id=824e3a0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-824e3a0c"]])

export default __exports__